import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';
import { plainText, requiredValidator} from '../../../../../../modules/validators';
import { trimSpaces, trimSpacesLeft } from '../../../../../../modules/formatters';
import { ATTENDEE_EMAIL_TEXT, ATTENDEE_ID_TEXT, CONNECTION_ACCOUNT_TEXT, CONNECTION_LINK_TEXT, CONNECTION_PASSWORD_TEXT, PANELIST_LABEL_TEXT, PANELIST_WEBINAR_ID, PARTICIPANT_ID_TEXT } from '../../../_connections/connections.texts';
import { urlValidator } from '../../../../../../modules/passport-pages/config';

export enum ChildPanelistLinkFieldKey {
    LABEL = 'label',
    ATTENDEE_ID = 'attendeeId',
    ATTENDEE_EMAIL = 'attendeeEmail',
    CONNECTION_LINK = 'connectionLink',
    WEBINAR_ID = 'connectionId',
    CONNECTION_PASSWORD = 'connectionPassword',
    CONNECTION_ACCOUNT = 'connectionAccount',
    PARTICIPANT_ID = 'participantId',
}

export const FORM_CONFIG = {
    [ChildPanelistLinkFieldKey.LABEL]: {
        labelDescriptor: PANELIST_LABEL_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
    [ChildPanelistLinkFieldKey.ATTENDEE_ID]: {
        labelDescriptor: ATTENDEE_ID_TEXT,
        defaultValue: '',
    },
    [ChildPanelistLinkFieldKey.ATTENDEE_EMAIL]: {
        labelDescriptor: ATTENDEE_EMAIL_TEXT,
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
        defaultValue: '',
    },
    [ChildPanelistLinkFieldKey.CONNECTION_LINK]: {
        labelDescriptor: CONNECTION_LINK_TEXT,
        formatters: [trimSpaces],
        validators: [requiredValidator, urlValidator],
        defaultValue: '',
    },
    [ChildPanelistLinkFieldKey.WEBINAR_ID]: {
        labelDescriptor: PANELIST_WEBINAR_ID,
        defaultValue: '',
    },
    [ChildPanelistLinkFieldKey.CONNECTION_PASSWORD]: {
        labelDescriptor: CONNECTION_PASSWORD_TEXT,
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
        defaultValue: ''
    },
    [ChildPanelistLinkFieldKey.CONNECTION_ACCOUNT]: {
        labelDescriptor: CONNECTION_ACCOUNT_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
    [ChildPanelistLinkFieldKey.PARTICIPANT_ID]: {
        labelDescriptor: PARTICIPANT_ID_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);